export default __webpack_public_path__ + "static/media/desmosActivity.4080e31a.png";